import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function Portfolio() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">Personal Portfolio</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={2}>
              Collection of personal projects, internship project and course
              proejcts.
            </Box>
            <Box mt={4} className="title">
              Tech Stacks
            </Box>
            <Box mt={1}>
              JavaScript (ES6), HTML5, CSS3, SCSS,React, React Router, Material
              UI, GitHub Pages, VS Code
            </Box>
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default Portfolio;
